import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

import type { NgTopologyConfiguration } from '@/app/topology';

export const OIDC_CLIENT_ID = 'Portal';

export const OIDC_SCOPES: readonly string[] = [
  'openid',
  'profile',
  'roles',
  'portal',
  'incident.create',
  'incident.caller.chat',
  'incident.caller.locate',
  'incident.collaboration',
  'incident.close',
  'incident.update',
  'incident.caller.live-video',
  'ems.progress.request.setState',
  'videoserver.media.consume',
  'apple-eed.call.data',
  'apple-eed.request.video',
  'apple-eed.request.media',
  'identity.incident.share.token',
  'offline_access',
];

export function createUserManager(topology: NgTopologyConfiguration): UserManager {
  return new UserManager({
    authority: topology.identityServerUrl,
    client_id: OIDC_CLIENT_ID,
    response_type: 'code',
    scope: OIDC_SCOPES.join(' '),
    redirect_uri: `${window.location.origin}/authentication/login-callback`,
    post_logout_redirect_uri: topology.identityServerUrl,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: false,
  });
}
